// extracted by mini-css-extract-plugin
export default {"main":"TemplateServiceProcess_main__ufpo8","texte":"TemplateServiceProcess_texte__q-2Z-","texte_experience":"TemplateServiceProcess_texte_experience__PymFI"};